import React from 'react';
import iconEmail from '../../sass/icons/icon-email.svg';
import iconFacebook from '../../sass/icons/icon-facebook-f.svg';
import iconInstagram from '../../sass/icons/icon-instagram.svg';
import iconLinkedIn from '../../sass/icons/icon-linkedin.svg';
import iconTwitter from '../../sass/icons/icon-twitter.svg';
// Icons
import iconWhatsapp from '../../sass/icons/icon-whatsapp.svg';
import iconYoutube from '../../sass/icons/icon-youtube.svg';
import TestCTA from '../TestCTA';
import './Social.scss';
import SocialMedia from './SocialMedia';



// import test from '../../sass/icons/fa'

const content = [
    {
        name: 'WhatsApp',
        background: '#50D169',
        icon: iconWhatsapp
    },
    {
        name: 'Facebook',
        background: '#4C6FBD',
        icon: iconFacebook
    },
    {
        name: 'Twitter',
        background: '#5CA6F4',
        icon: iconTwitter
    },
    {
        name: 'Instagram',
        background: 'radial-gradient(circle at 30% 107%, #fdf497 0%, #fdf497 5%, #fd5949 45%,#d6249f 60%,#285AEB 100%)',
        backgroundType: 'image',
        icon: iconInstagram
    },
    {
        name: 'Youtube',
        background: '#F91000',
        icon: iconYoutube
    },
    // {
    //     name: 'Vimeo',
    //     background: '#181818',
    //     icon: iconVimeo
    // },
    {
        name: 'LinkedIn',
        background: '#0077B5',
        icon: iconLinkedIn
    },
    {
        name: 'Email',
        background: 'linear-gradient(135deg, #00BC9B 0%, #00BC9B 0%, #18A2A9 26%, #18A2A9 26%, #2F8AB7 50%, #2F8AB7 50%, #3089B7 52%, #5D59D2 100%)',
        backgroundType: 'image',
        icon: iconEmail
    }
]

const renderItems = data =>  data.map(item => <SocialMedia key={item.name} {...item} />)

const Social = () => {
    return (
        <div className="container">
            <div className="grid-center">
                <div className="social-icons">
                    <h4>O Talkative está integrado com</h4>
                    <ul className="social-icon-list">
                        { renderItems(content) }
                    </ul>
                    <TestCTA />
                </div>
            </div>
        </div>
    );
};

export default Social;


// WEBPACK FOOTER //
// ./src/components/Social/index.js